'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Icon = require('../Icon');

var _Icon2 = _interopRequireDefault(_Icon);

var _prefix = require('../../utils/prefix');

var _prefix2 = _interopRequireDefault(_prefix);

require('./styles.sass');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var modifiers = (0, _prefix2.default)('content-error--');

var ContentError = function ContentError(_ref) {
  var title = _ref.title,
      error = _ref.error,
      large = _ref.large,
      onRetryClick = _ref.onRetryClick;
  return _react2.default.createElement(
    'div',
    { className: (0, _classnames2.default)('content-error', modifiers({ large: large })) },
    _react2.default.createElement(_Icon2.default, { material: true, name: 'error outline', color: '#F44336', large: true }),
    _react2.default.createElement(
      'h3',
      { className: 'title is-3 content-error__title' },
      title
    ),
    error && _react2.default.createElement(
      'div',
      { className: 'content-error__error' },
      typeof error === 'string' ? error : error.response && error.response.data ? error.response.data.message : error.message
    ),
    onRetryClick && _react2.default.createElement(
      'div',
      { className: 'content-error__retry-container' },
      _react2.default.createElement(
        'a',
        { className: 'button is-danger is-outlined', onClick: function onClick(e) {
            return e.preventDefault() || onRetryClick();
          } },
        'Retry'
      )
    )
  );
};

ContentError.propTypes = {
  title: _propTypes2.default.string,
  error: _propTypes2.default.any,
  large: _propTypes2.default.bool,
  onRetryClick: _propTypes2.default.func
};

ContentError.defaultProps = {
  title: 'An error occurred'
};

exports.default = ContentError;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@taxfyle/web-commons/lib/components/ContentError/index.js
// module id = 185
// module chunks = 0